import type { PayPeriodType, WeekStartsOn } from './time-tracking-settings.dto.js';

export const timeTrackingTimezoneSourceValues = ['company', 'store', 'location', 'employee'] as const;
export type TimeTrackingTimezoneSource = (typeof timeTrackingTimezoneSourceValues)[number];

export interface TimeTrackingPolicyDto {
  id: string;
  companyId: string;
  effectiveFrom: string; // ISO date (YYYY-MM-DD)
  effectiveTo: string | null; // ISO date (YYYY-MM-DD)
  periodType: PayPeriodType;
  weekStartsOn: WeekStartsOn;
  timezoneSource: TimeTrackingTimezoneSource;
  graceWindowDaysForAdjustments: number;
  allowManagerAdjustPastPeriods: boolean;
  allowEmployeeSelfAdjust: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListTimeTrackingPoliciesRequest {
  companyId: string;
}

export interface ListTimeTrackingPoliciesResponse {
  items: TimeTrackingPolicyDto[];
}

export interface CreateTimeTrackingPolicyRequest {
  companyId: string;
  effectiveFrom: string; // ISO date (YYYY-MM-DD)
  effectiveTo?: string | null; // ISO date (YYYY-MM-DD)
  periodType: PayPeriodType;
  weekStartsOn: WeekStartsOn;
  timezoneSource: TimeTrackingTimezoneSource;
  graceWindowDaysForAdjustments: number;
  allowManagerAdjustPastPeriods: boolean;
  allowEmployeeSelfAdjust: boolean;
}

export interface CreateTimeTrackingPolicyResponse {
  policy: TimeTrackingPolicyDto;
}

export interface UpdateTimeTrackingPolicyRequest {
  companyId: string;
  policyId: string;
  effectiveFrom?: string; // ISO date (YYYY-MM-DD)
  effectiveTo?: string | null; // ISO date (YYYY-MM-DD)
  periodType?: PayPeriodType;
  weekStartsOn?: WeekStartsOn;
  timezoneSource?: TimeTrackingTimezoneSource;
  graceWindowDaysForAdjustments?: number;
  allowManagerAdjustPastPeriods?: boolean;
  allowEmployeeSelfAdjust?: boolean;
}

export interface UpdateTimeTrackingPolicyResponse {
  policy: TimeTrackingPolicyDto;
}
